import { render, staticRenderFns } from "./SuperAdminAiStreamerGamesSettings.vue?vue&type=template&id=49c28d76&scoped=true&lang=pug"
import script from "./SuperAdminAiStreamerGamesSettings.vue?vue&type=script&lang=ts"
export * from "./SuperAdminAiStreamerGamesSettings.vue?vue&type=script&lang=ts"
import style0 from "./SuperAdminAiStreamerGamesSettings.vue?vue&type=style&index=0&id=49c28d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c28d76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VRow,VSelect,VTextField})
